import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/button'

export interface ServiceCardProps {
  title: string
  linkUrl: string
  Icon: ReactNode
}

export function ServiceCard({ title, linkUrl, Icon }: ServiceCardProps) {
  return (
    <Button asChild variant="secondary">
      <Link
        to={linkUrl}
        className="flex h-52 flex-col items-center justify-center gap-2 rounded-xl bg-white text-bios-secondary 2xl:h-52"
      >
        {Icon}
        <p className="text-xl font-bold text-bios-title 2xl:text-2xl">
          {title}
        </p>
      </Link>
    </Button>
  )
}
